import React, { Component } from "react";
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";

const SimpleGoogleMap = withGoogleMap((props) => (
  <GoogleMap
    defaultZoom={15}
    defaultCenter={{ lat: 51.400956, lng: -0.354436 }}
  >
    {props.markers.map((marker) => (
      <Marker {...marker} />
    ))}
  </GoogleMap>
));

class Contact extends Component {
  state = {
    markers: [
      {
        position: {
          lat: 51.400956,
          lng: -0.354436,
        },
        key: "Molesey Photographic Club",
        defaultAnimation: 4,
      },
    ],
  };

  render() {
    return (
      <div>
        <div className="container">
          <h1>Contact Us</h1>

          <h2>Committee Members</h2>
          <table className="table">
            <tbody>
              <tr>
                <th scope="row">President</th>
                <td>John Hoskins ARPS, AFIAP, DPAGB, BPE3* </td>
              </tr>
              <tr>
                <th scope="row">Vice Presidents</th>
                <td>Ann Beauchamp</td>
              </tr>
              <tr>
                <th scope="row">Chairman</th>
                <td>Terri Bethell LRPS</td>
              </tr>
              <tr>
                <th scope="row">Treasurer and Membership Secretary</th>
                <td>Richard Escott LRPS</td>
              </tr>
              <tr>
                <th scope="row">Secretary</th>
                <td>Nathan Comben</td>
              </tr>
              <tr>
                <th scope="row">Programme Secretary</th>
                <td>Terri Bethell LRPS</td>
              </tr>
              <tr>
                <th scope="row">Publicity and Exhibitions Secretary</th>
                <td>Terri Bethell LRPS</td>
              </tr>
              <tr>
                <th scope="row">External Competitions Secretary</th>
                <td>John Hoskins ARPS, AFIAP, DPAGB, BPE3*</td>
              </tr>
              <tr>
                <th scope="row">Committee Members</th>
                <td>Bevil Templeton-Smith</td>
              </tr>
            </tbody>
          </table>
          <br />

          <p>
            To join the club, contact either the club secretary or the
            membership secretary and ask for the forms. The Data Protection act
            covers your details. Membership subscription rates are £45.00 for
            full membership, £22.50 for students and country members. For
            further enquiries, e-mail us at{" "}
            <a href="mailto:molesey_photo_club@yahoo.co.uk">
              molesey_photo_club@yahoo.co.uk
            </a>
          </p>
        </div>

        <div className="container mapContainer">
          <SimpleGoogleMap
            containerElement={<div style={{ height: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            markers={this.state.markers}
          />
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx